export default __webpack_public_path__ + "static/media/MarutiConnectSession.49b8bacc.JPG";